export const generateFeatureColorPalette = (count: number): number[] => {
  const colors: number[] = [];
  const phi = 0.61803398875;
  let h = 0.0;
  const toInt = (r: number, g: number, b: number) =>
    ((r & 0xff) << 16) | ((g & 0xff) << 8) | (b & 0xff);

  for (let i = 0; i < count; i++) {
    h = (h + phi) % 1;
    const s = 0.62;
    const l = 0.52;
    const c = (1 - Math.abs(2 * l - 1)) * s;
    const hp = h * 6;
    const x = c * (1 - Math.abs((hp % 2) - 1));
    let r = 0;
    let g = 0;
    let b = 0;

    if (hp >= 0 && hp < 1) {
      r = c;
      g = x;
    } else if (hp < 2) {
      r = x;
      g = c;
    } else if (hp < 3) {
      g = c;
      b = x;
    } else if (hp < 4) {
      g = x;
      b = c;
    } else if (hp < 5) {
      r = x;
      b = c;
    } else {
      r = c;
      b = x;
    }

    const m = l - c / 2;
    const R = Math.round((r + m) * 255);
    const G = Math.round((g + m) * 255);
    const B = Math.round((b + m) * 255);
    colors.push(toInt(R, G, B));
  }

  return colors;
};
